module.exports = __webpack_public_path__ + "static/media/behind.4ae6fdf2.svg";